module.exports = __webpack_public_path__ + "img/linkedin.d7d032c0.png";